import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';


function renderInputComponent(inputProps) {
  const { classes, inputRef = () => {}, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input,
        },
      }}
      {...other}
    />
  );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.label, query);
  const parts = parse(suggestion.label, matches);

  return (
    <MenuItem selected={isHighlighted} component="div">
      <div>
        {parts.map((part, index) => {
          return part.highlight ? (
            <span key={String(index)} style={{ fontWeight: 500 }}>
              {part.text}
            </span>
          ) : (
            <strong key={String(index)} style={{ fontWeight: 300 }}>
              {part.text}
            </strong>
          );
        })}
      </div>
    </MenuItem>
  );
}

function getSuggestionValue(suggestion) {
  return suggestion.label;
}

const styles = theme => ({
  root: {
    height: 250,
    flexGrow: 1,
  },
  container: {
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
});

class RenderSuggestionInput extends React.Component {

  handleSuggestionsFetchRequested = ({ value }) => {
    this.props.fetchSuggestions(value);

  };

  handleSuggestionsClearRequested = () => {
    this.props.handleSuggestions({
      suggestions: [],
    });
  };


  render() {
    const {classes, input, label, meta: { touched, error }, ...custom} = this.props;

    const autosuggestProps = {
      renderInputComponent,
      suggestions: custom.suggestions,
      onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
      getSuggestionValue,
      renderSuggestion,
    };

    return (
      <div >
        <Autosuggest
          {...autosuggestProps}
          id={this.props.id}
          inputProps={{
            ...input,
            disabled: this.props.disabled,
            classes,
            label: label,
            error: !!(touched && error),
            autoComplete: 'off',
            autoCapitalize: 'off',
            autoCorrect: 'off',
            spellCheck: 'off',
            onKeyPress: (evt) => {
              if(evt.key === 'Enter'){
                evt.preventDefault()
              }
            }
          }}
          onSuggestionHighlighted={(suggestion) => {
            try {
              input.onChange(suggestion.suggestion.label);
            } catch (e) {}
          }}
          theme={{
            container: classes.container,
            suggestionsContainerOpen: this.props.customSuggestionsContainerOpen?
              this.props.customSuggestionsContainerOpen
              :
              classes.suggestionsContainerOpen,
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion,
          }}
          shouldRenderSuggestions={this.props.shouldRenderSuggestions}
          renderSuggestionsContainer={options => (
            <Paper {...options.containerProps} square>
              {options.children}
            </Paper>
          )}
        />
      </div>
    );
  }
}

RenderSuggestionInput.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RenderSuggestionInput);



// WEBPACK FOOTER //
// ./src/components/inputs/renderSuggestionInput.js